"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichOptions = void 0;
var auto_correct_1 = require("./auto-correct");
var bookmarks_1 = require("./bookmarks");
var control_1 = require("./control");
var fields_1 = require("./fields");
var fonts_1 = require("./fonts");
var mail_merge_1 = require("./mail-merge");
var pdf_1 = require("./pdf");
var printing_1 = require("./printing");
var protection_1 = require("./protection");
var search_1 = require("./search");
var spell_checker_1 = require("./spell-checker");
var RichOptions = (function () {
    function RichOptions(cultureOpts) {
        this.control = new control_1.ControlOptions();
        this.mailMerge = new mail_merge_1.MailMergeOptions();
        this.fields = new fields_1.FieldsSettings();
        this.documentProtection = new protection_1.DocumentProtectionSettings();
        this.printing = new printing_1.PrintingSettings();
        this.bookmarks = new bookmarks_1.BookmarksSettings();
        this.spellChecker = new spell_checker_1.SpellCheckerSettings();
        this.autoCorrect = new auto_correct_1.AutoCorrectSettings();
        this.pdf = new pdf_1.PdfSettings();
        this.search = new search_1.SearchSettings();
        this.fonts = new fonts_1.FontsSettings();
        this.cultureOpts = cultureOpts;
    }
    Object.defineProperty(RichOptions.prototype, "maxSpellRequestLength", {
        get: function () {
            return this.spellChecker.maxRequestLength;
        },
        enumerable: false,
        configurable: true
    });
    RichOptions.prototype.clone = function () {
        var result = new RichOptions(this.cultureOpts);
        result.control = this.control.clone();
        result.mailMerge = this.mailMerge.clone();
        result.fields = this.fields.clone();
        result.documentProtection = this.documentProtection.clone();
        result.printing = this.printing.clone();
        result.bookmarks = this.bookmarks.clone();
        result.spellChecker = this.spellChecker.clone();
        result.autoCorrect = this.autoCorrect.clone();
        result.cultureOpts = this.cultureOpts.clone();
        result.pdf = this.pdf.clone();
        result.search = this.search.clone();
        result.fonts = this.fonts.clone();
        return result;
    };
    return RichOptions;
}());
exports.RichOptions = RichOptions;
